import { apiClient } from "api/client";

export interface ContactUsPayload {
  full_name: string;
  email: string;
  subject: string;
  message: string;
}

export interface ContactUsResponse {
  message: string;
  data: null;
}

export const contactUsService = (data: ContactUsPayload) => {
  return apiClient.post<ContactUsResponse>("/contact-us/", data);
};
